// LIBRARY
import React from 'react';
import { Button, Modal } from 'antd';
import PropTypes from 'prop-types';
// IMAGES
import { CheckIcon } from '../../../../images';

// CSS
import './actions.css'

const ModalContent = (
	<div>
		<img src={CheckIcon} alt="check icon" height='70px' width='auto' style={{marginBottom:'10px'}} />
		<p>You have successfully saved a result!</p>
		<p>A notification will be sent once the request has been verified.</p>
	</div>
);

// class Actions extends React.Component {
function Actions({ saveIresult, closeDrawer }) {
// state = { visible: false }

  // showModal = () => {
  //   this.setState({
  //     visible: true
  //   });
  // }

  // handleCancel = (e) => {
  //   console.log(e);
  //   this.setState({
  //     visible: false
  //   });
  // }

  const countDown = () => {
    let secondsToGo = 3;
    
    saveIresult();
    
    const modal = Modal.success({
      title: '',
      content: ModalContent,
      className: 'save-patientinfo-modal'
    });
    const timer = setInterval(() => {
      secondsToGo -= 1;
    }, 1000);
    setTimeout(() => {
      clearInterval(timer);
      modal.destroy();
      closeDrawer();
    }, secondsToGo * 1000);
  }
 
    return(
      <div style={{ textAlign:'right', marginTop: '30px' }} className="action-container">
        <Button 
          htmlType="submit" 
          className="save-button" 
          // onClick={countDown}
          >USE SELECTED RESULT</Button>
      </div>
    );
  // }
}

Actions.PropType = {
  // saveIresult: PropTypes.func.isRequired,
  closeDrawer: PropTypes.func,
}

export default Actions;